import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerAccountUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.account.update),
			switchMap((action) =>
				this.consumerService.accountUpdate(action.request).pipe(
					map(() => ConsumerActions.account.updateSuccess()),
					catchError((error) =>
						of(ConsumerActions.account.updateFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService
	) {}
}
